/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1051
 */

module.exports = {
  wrapper: "UserAvatar_wrapper__29KLn",
  image: "UserAvatar_image__1_bHH",
  loginButton: "UserAvatar_loginButton__nsu0q"
}
